// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d14671f2","453":"a8bb63fa","732":"68c43a09"}[chunkId] + ".chunk.js";
};